import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API, withCredentials: true });

export const startScan = (url) => apiClient.post("/scan", { url }).then((r) => r.data);
export const getScan = (id) => apiClient.get(`/scan/${id}`).then((r) => r.data);
export const getReport = (domain) => apiClient.get(`/report/${domain}`).then((r) => r.data);
export const getRecentReports = (limit = 12) =>
  apiClient.get(`/reports/recent`, { params: { limit } }).then((r) => r.data);
export const getStats = () => apiClient.get("/stats").then((r) => r.data);
export const getPricing = () => apiClient.get("/pricing").then((r) => r.data);
export const createCheckout = (scanId, originUrl, email) =>
  apiClient
    .post("/checkout", { scan_id: scanId, package_id: "pro_unlock", origin_url: originUrl, email })
    .then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  apiClient.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const resendDeliveryEmail = (scanId) =>
  apiClient.post(`/scan/${scanId}/resend-email`).then((r) => r.data);

export const badgeUrl = (domain, opts = {}) => {
  const url = `${API}/badge/${domain}.svg`;
  const qs = new URLSearchParams();
  if (opts.variant) qs.set("variant", opts.variant);
  if (opts.theme) qs.set("theme", opts.theme);
  if (opts.size) qs.set("size", opts.size);
  const s = qs.toString();
  return s ? `${url}?${s}` : url;
};
